import { Col, notification, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import SubHeader from '../../../components/SubHeader';
import apiShipper from '../../../services/apiShipper';
import { getColumns } from './columns';
import { Content, Table } from './styles';

/**
 * Página para a listagem de clientes
 */
export default function ListagemClientes() {
  const [listClient, setListClient] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const history = useHistory();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    position: ['bottomCenter'],
  });
  const [filtersPage, setFiltersPage] = useState({});

  const definirOrdenacao = (params, sorter) => {
    const order = sorter.order === 'ascend' ? 'ASC' : 'DESC';

    params.orderBy = order;
    params.sortBy = sorter.columnKey;

    return params;
  };

  const definirFiltrosDinamicos = (params, filters) => {
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        const [value] = filters[key];

        const possibleKeys = ['razao_social', 'cnpj_resumido'];
        if (possibleKeys.includes(key)) {
          params[key] = String(value);
        }
      }
    });
    return params;
  };

  const handlerOnChangePagination = async () => {
    try {
      setLoadingTable(true);
      let options = {
        page: pagination.current,
        size: pagination.pageSize,
      };

      if (filtersPage?.sorter?.order) {
        options = {
          ...definirOrdenacao(options, filtersPage.sorter),
        };
      }

      if (filtersPage?.filters && Object.keys(filtersPage.filters).length) {
        options = {
          ...definirFiltrosDinamicos(options, filtersPage.filters),
        };
      }

      const response = await apiShipper.get('/clientes/tmov/raiz', {
        params: { ...options },
      });

      setListClient(response.data.content);

      const {
        page: current,
        size: pageSize,
        total_elements: total,
      } = response.data;

      setPagination({
        ...pagination,
        current,
        pageSize,
        total,
      });
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os clientes',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingTable(false);
    }
  };

  // função que inicia na construção do componente
  useEffect(() => {
    /**
     * Recupera todos os clientes da api-shipper
     */
    async function getAllClient() {
      handlerOnChangePagination();
    }

    getAllClient();
  }, [filtersPage]);

  /**
   * Redireciona o usuário para tela de edição de um cliente.
   * @param {Number} cnpj_resumido cnpj_resumido do cliente
   */
  const handleEditClient = ({ cnpj_resumido }) => {
    history.push(`clientes/${cnpj_resumido}`);
  };

  const onChangeTable = (paginationParam, filters, sorter) => {
    setPagination({
      ...paginationParam,
    });
    setFiltersPage({
      ...filtersPage,
      filters,
      sorter,
    });
  };

  const columnsTable = getColumns(handleEditClient, filtersPage);

  return (
    <>
      <SubHeader title="LISTAGEM DE CLIENTES" />
      <Content>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Table
                loading={loadingTable}
                bordered={true}
                dataSource={listClient.map((client, key) => ({
                  ...client,
                  key,
                }))}
                onChange={onChangeTable}
                columns={columnsTable}
                pagination={pagination}
              />
            </Col>
          </Row>
        </Col>
      </Content>
    </>
  );
}
